<!-- Revised on 2024/11/27 by mnavarro -->
<template>
  <div v-if="total > 0" class="d-flex align-items-center justify-content-end">
      <nav class="dataTable-pagination">
        <ul class="dataTable-pagination-list">
          <li v-if="current > 5" class="page-item">
            <button class="page-link" style="cursor: pointer;" type="button" :title="$t('key_pager_goto_page') + ' ' + (current - 5)" @click.prevent="skipPages(-5)">«</button>
          </li>
          <li v-if="current > 1" class="page-item">
            <button class="page-link" style="cursor: pointer;" type="button" :title="$t('key_pager_goto_page') + ' ' + (current - 1)" @click.prevent="skipPages(-1)">‹</button>
          </li>
          
          <li v-for="item in range" :key="item" :class="['page-item', { active: item === current }]">
            <button class="page-link" style="cursor: pointer;" type="button" :title="$t('key_pager_goto_page') + ' ' + item" @click.prevent="changedPage(item)">{{ item }}</button>
          </li>

          <li v-if="current < total" class="page-item">
            <button class="page-link" style="cursor: pointer;" type="button" :title="$t('key_pager_goto_page') + ' ' + (current + 1)" @click.prevent="skipPages(1)">›</button>
          </li>
          <li v-if="current + 5 <= total" class="page-item">
            <button class="page-link" style="cursor: pointer;" type="button" :title="$t('key_pager_goto_page') + ' ' + (current + 5)" @click.prevent="skipPages(5)">»</button>
          </li>
        </ul>
      </nav>
  </div>
</template>

<script>

  export default {
    name: "Pager",
    props: {
      color: {
        type: String,
        default: "sevica",
      },
      size: {
        type: String,
        default: "md",
      },
      total: {
        type: Number,
        default: 1
      },
      current: {
        type: Number,
        default: 1,
      },
    },
    emits: ['changed-page'],
    computed: {
      range() {
        const visible = 5;
        let start = Math.max(this.current - 2, 1);
        let end = Math.min(start + visible - 1, this.total);

        if (end - start < visible - 1) {
          start = Math.max(end - visible + 1, 1);
        }

        const ret = [];
        for (let i = start; i <= end; i++) ret.push(i);
        return ret;
      }
    },
    methods: {
      changedPage(page) {
        if (page !== this.current) this.$emit('changed-page', page);
      },
      skipPages(offset) {
        let toPage = this.current + offset;
        if (toPage < 1) toPage = 1;
        if (toPage > this.total) toPage = this.total;
        this.changedPage(toPage);
      },
      getClasses(index, current) {
        return index === current ? "active" : "";
      },
    },
  };

</script>